import Pagination from 'rc-pagination/lib/locale/zh_CN';
import DatePicker from '../date-picker/locale/zh_CN';
import TimePicker from '../time-picker/locale/zh_CN';
import Calendar from '../calendar/locale/zh_CN';
export default {
    locale: 'zh-cn',
    Pagination,
    DatePicker,
    TimePicker,
    Calendar,
    Table: {
        filterTitle: '',
        filterConfirm: '',
        filterReset: '',
        emptyText: '',
        selectAll: '',
        selectInvert: '',
    },
    Modal: {
        okText: '',
        cancelText: '',
        justOkText: '',
    },
    Popconfirm: {
        cancelText: '',
        okText: '',
    },
    Transfer: {
        notFoundContent: '',
        searchPlaceholder: '',
        itemUnit: '',
        itemsUnit: '',
    },
    Select: {
        notFoundContent: '',
    },
    Upload: {
        uploading: '',
        removeFile: '',
        uploadError: '',
        previewFile: '',
    },
};



// WEBPACK FOOTER //
// ./components/locale-provider/zh_CN.tsx